<div class="saas-ui date-picker-wrapper">
  <label class="date-range-label">
    {{ label() }}
    <div
      #calendarInputWrapper
      class="input-wrapper"
      (click)="toggleCalendar($event)">
      <input type="text" [value]="getDatePickerLabel()" readonly />
      <i class="material-symbols-outlined calendar-icon" aria-hidden="true">
        calendar_today
      </i>
    </div>
  </label>
  @if (compareEnabled) {
    <label class="compare" for="compareSwitchOutside">
      Compare
      <p-inputSwitch
        id="compareSwitchOutside"
        class="compare-switch mt-1"
        [(ngModel)]="compareToggledOn"
        (onChange)="onOutsideCompareToggle($event.checked)">
      </p-inputSwitch>
    </label>
  }
</div>

<p-dialog
  [(visible)]="showCalendar"
  appendTo="body"
  styleClass="date-picker-popup fiscal-calendar-popup"
  [showHeader]="false"
  [modal]="true"
  [focusOnShow]="false"
  [focusTrap]="true"
  (onShow)="onDialogShow()"
  (onHide)="cancel()"
  transitionOptions="0ms">
  <div #calendarPopup class="date-picker-popup-content">
    <!-- Left Side Panel -->
    <div
      class="left-side saas-ui saas-ui-size-default"
      [class.compare]="compareToggledOn">
      <!-- Content (top section) -->
      <div class="left-side-content">
        <!-- Title -->
        <div class="date-picker-title">
          <span class="sh2 text-gray-1000">Date Presets</span>
        </div>

        <!-- Info Bar -->
        <div class="date-picker-info-bar">
          <span class="c1 text-gray-800">{{ availabilityInfoText }}</span>
          <i
            class="material-symbols-outlined icon-small text-gray-500"
            aria-hidden="true">
            info
          </i>
        </div>

        <!-- Range Picker: Preset Dropdown + Date Inputs -->
        <div class="range-picker-section">
          <m-dropdown
            class="preset-dropdown"
            width="100%"
            panelStyleClass="fiscal-preset-panel"
            [options]="datePresetOptions"
            [(ngModel)]="selectedDatePreset"
            (formControlChange)="onDatePresetChange($event.value)"
            optionLabel="label"
            optionValue="value"
            placeholder="Select preset">
          </m-dropdown>
          <div class="date-inputs-row">
            <input
              pInputText
              type="text"
              class="date-input"
              [value]="displayDates().start"
              (focus)="onInputFocus($event, 'startDate')"
              (blur)="onInputBlur($event, 'startDate')"
              (change)="onInputChange($event, 'startDate')" />
            <span class="date-separator">-</span>
            <input
              pInputText
              type="text"
              class="date-input"
              [value]="displayDates().end"
              (focus)="onInputFocus($event, 'endDate')"
              (blur)="onInputBlur($event, 'endDate')"
              (change)="onInputChange($event, 'endDate')" />
          </div>
        </div>

        <!-- Compare Section -->
        <div
          class="compare-section"
          [class.compare]="compareToggledOn && compareEnabled">
          @if (compareEnabled) {
            <div class="input-switch">
              <label for="compareSwitch">
                <p-inputSwitch
                  id="compareSwitch"
                  class="compare-toggle"
                  [(ngModel)]="compareToggledOn"
                  (onChange)="onCompareToggle($event.checked)">
                </p-inputSwitch>
                <span class="toggle-text">Compare with</span>
              </label>
            </div>
          }
          @if (compareToggledOn && compareEnabled) {
            <!-- Compare Preset Dropdown -->
            <div class="preset-section">
              <m-dropdown
                class="preset-dropdown"
                width="100%"
                panelStyleClass="fiscal-preset-panel"
                [options]="comparePresetOptions"
                [(ngModel)]="selectedComparePreset"
                (formControlChange)="onComparePresetChange($event.value)"
                optionLabel="label"
                optionValue="value"
                placeholder="Select preset">
              </m-dropdown>
            </div>

            <div class="date-inputs-row">
              <input
                pInputText
                type="text"
                class="date-input"
                [value]="displayDates().prevStart"
                (focus)="onInputFocus($event, 'startDateCompare')"
                (blur)="onInputBlur($event, 'startDateCompare')"
                (change)="onInputChange($event, 'startDateCompare')" />
              <span class="date-separator">-</span>
              <input
                pInputText
                type="text"
                class="date-input"
                [value]="displayDates().prevEnd"
                (focus)="onInputFocus($event, 'endDateCompare')"
                (blur)="onInputBlur($event, 'endDateCompare')"
                (change)="onInputChange($event, 'endDateCompare')" />
            </div>
          }
        </div>
      </div>

      <!-- Footer -->
      <div class="date-picker-footer d-flex gap-3 mt-auto">
        <m-button type="primary" label="Save" (click)="apply()"></m-button>
        <m-button type="secondary" label="Cancel" (click)="cancel()"></m-button>
      </div>
    </div>

    <!-- Right Side - Fiscal Calendar -->
    <div class="calendar-side fiscal">
      @if (showCalendar) {
        <m-fiscal-calendar
          [months]="months()"
          [startDate]="calendarDates().start"
          [endDate]="calendarDates().end"
          [previousStartDate]="
            compareToggledOn ? calendarDates().compareStart : null
          "
          [previousEndDate]="
            compareToggledOn ? calendarDates().compareEnd : null
          "
          [minDate]="formattedMinDate()"
          [maxDate]="formattedMaxDate()"
          (selectedDateRange)="onFiscalDateSelected($event)">
        </m-fiscal-calendar>
      }
    </div>
  </div>
</p-dialog>
